/* eslint-disable @typescript-eslint/no-explicit-any */

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {
  return null;
};
const isSSR = (() => {
  try {
    return !(typeof window !== 'undefined' && document !== undefined);
  } catch (e) {
    return true;
  }
})();
const on = (() => {
  if (isSSR) {
    return noop;
  }
  return (element, event, handler, options) => {
    return element && element.addEventListener(event, handler, options || false);
  };
})();
const off = (() => {
  if (isSSR) {
    return noop;
  }
  return (element, event, handler, options) => {
    return element && element.removeEventListener(event, handler, options || false);
  };
})();
const contains = (root, ele) => {
  let node = ele;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
};

export { contains, isSSR, noop, off, on };
